module.exports = __webpack_public_path__ + "static/media/468x60_0059_en.851d7599.jpg";